<template>
  <Public header="custom-header"
          headerText="ข้อมูลขอใบรับรองอิเล็กทรอนิกส์และการลงลายมือชื่อดิจิทัล"
          headerSubText="สำหรับรับรองตัวตนของผู้ใช้บริการเพื่อนำไปใช้ในการทำธุรการออนไลน์แบบปลอดภัย">

    <div class="tw-container tw-mx-auto tw-mt-8 tw-mb-16 tw-max-w-xl tw-p-4" id="buy-certification">

      <div class="tw-prose tw-max-w-none tw-text-left tw-pb-10">
        <h3>คุณต้องการขอใบรับรองอิเล็กทรอนิกส์และการลงลายมือชื่อดิจิทัล</h3>
        <div class="tw-flex tw-space-x-2 tw-justify-center tw-items-center tw-py-2">
          <div @click="onChangeOption(true)"
               v-bind:class="{ 'tw-bg-light-green tw-text-white tw-border-light-green': option , 'tw-bg-white tw-text-black tw-border-gray-500-50': !option }"
               class="tw-cursor-pointer tw-rounded-lg tw-py-2 tw-w-1/2 tw-border tw-text-center">
            ต้องการ
          </div>
          <div @click="onChangeOption(false)"
               v-bind:class="{ 'tw-bg-light-green tw-text-white tw-border-light-green': !option , 'tw-bg-white tw-text-black tw-border-gray-500-50': option }"
               class="tw-cursor-pointer tw-rounded-lg tw-py-2 tw-w-1/2 tw-border tw-text-center">
            ไม่ต้องการ
          </div>
        </div>
        <h4>ค่าใช้จ่ายในการขอใบรับรองอิเล็กทรอนิกส์และการลงลายมือชื่อดิจิทัล</h4>
        <div class="tw--mb-7 tw-flex tw-relative" v-if="option">
          <v-checkbox
            v-on:change="updatePricing"
            v-model="requestCertificate"
            label="ใบรับรองอิเล็กทรอนิกส์"
          ></v-checkbox>
          <span class="tw-mt-5 tw-absolute tw-right-1/3"><strong>3,000 บาท</strong></span>
        </div>
        <div class="tw--mb-7 tw-flex tw-relative" v-if="option">
          <v-checkbox
            v-on:change="updatePricing"
            v-model="requestDigitalSignature"
            label="การลงลายมือชื่อดิจิทัล"
          ></v-checkbox>
          <span class="tw-mt-5 tw-absolute tw-right-1/3"><strong>2,000 บาท</strong></span>
        </div>
        <div class="tw--mb-7 tw-flex tw-relative">
          <v-checkbox
            disabled="disabled"
            v-model="service"
            label="บริการ e-Tax Setup"
          ></v-checkbox>
          <span class="tw-mt-5 tw-absolute tw-right-1/3"><strong>4,900 บาท</strong></span>
        </div>
        <div class="tw--mb-7 tw-flex tw-relative" v-if="option">
          <v-checkbox
            v-on:change="updatePricing"
            v-model="requestERPConnect"
            label="บริการเชื่อมต่อ ERP"
          ></v-checkbox>
          <span class="tw-mt-5 tw-absolute tw-right-1/3"><strong>15,000 บาท</strong></span>
        </div>
      </div>
      <hr>

      <div class="tw-prose tw-max-w-none tw-text-left tw-pb-6 tw-pt-5">
        <h3>ยอดรวมค่าใช้จ่าย</h3>
        <h1 class="tw-text-light-green">{{ price.toLocaleString() }} บาท</h1>
      </div>
      <hr>

      <div class="tw-prose tw-max-w-none tw-text-left tw-pb-6 tw-pt-5">
        <h3>ที่อยู่สำหรับจัดส่ง</h3>
        <v-checkbox
              @change="onChangeSelect($event)"
              :value="useSameCompanyAddress"
              label="ใช้ที่อยู่เดียวกับบริษัท"
            ></v-checkbox>
        <form ref="form" @submit="onsubmit" id="certification">
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                placeholder=" "
                outlined
                label="เลขที่"
                v-model="address.addressNo"
                :rules="inputRule"
                :disabled="loading || useSameCompanyAddress"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                placeholder=" "
                outlined
                label="อาคาร / ชั้น / ห้อง"
                v-model="address.building"
                :disabled="loading || useSameCompanyAddress"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                placeholder=" "
                outlined
                label="ตรอก / ซอย"
                v-model="address.alley"
                :disabled="loading || useSameCompanyAddress"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                placeholder=" "
                outlined
                label="หมู่ที่"
                v-model="address.village"
                :disabled="loading || useSameCompanyAddress"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                placeholder=" "
                outlined
                label="ถนน"
                v-model="address.street"
                :disabled="loading || useSameCompanyAddress"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <div class="material-textfield">
                <ThailandAutoComplete v-model="address.postCode" type="zipcode" @select="select"
                                      size="large" color="#42b883" placeholder=" "/>
                <label>รหัสไปรษณีย์</label>
              </div>
              <div v-if="alertZipcode" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pt-0 pb-4">
              <div class="material-textfield">
                <ThailandAutoComplete v-model="address.district" type="amphoe" @select="select"
                                      color="#42b883" size="large" placeholder=" "/>
                <label>เขต / อำเภอ</label>
              </div>
              <div v-if="alertAmphoe" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pt-0 pb-4">
              <div class="material-textfield">
                <ThailandAutoComplete v-model="address.subDistrict" type="district"
                                      @select="select" color="#42b883" size="large" placeholder=" "/>
                <label>แขวง / ตำบล</label>
              </div>
              <div v-if="alertDistrict" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <div class="material-textfield">
                <ThailandAutoComplete v-model="address.province" type="province" @select="select"
                                      size="large" color="#42b883" placeholder=" "/>
                <label>จังหวัด</label>
              </div>
              <div v-if="alertProvince" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
          </v-row>
        </form>
      </div>
      <div class="tw-grid tw-grid-cols-2 tw-gap-4">
        <div
          class="tw-cursor-pointer tw-w-3/4 tw-px-10 tw-py-2 tw-rounded-md tw-text-center tw-border tw-border-light-green tw-text-light-green tw-justify-self-end">
          ย้อนกลับ
        </div>
        <button form="certification" type="submit" :disabled="loading" class="tw-cursor-pointer tw-w-3/4 tw-px-10 tw-py-2 tw-rounded-md tw-text-center tw-bg-light-green tw-text-white tw-shadow-md">
          ดำเนินการต่อ
        </button>
      </div>
    </div><!--container-->

    <footer-web></footer-web>
  </Public>
</template>

<script>
import {mapState} from 'vuex'
import FooterWeb from '@/components/public/footer'
import Public from '@/components/public/public-main-template'
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import router from "@/router";

const _ = require('lodash');

let addressObjectDetail = {
  addressNo: "",
  building: "",
  village: "",
  alley: "",
  street: "",
  province: "",
  district: "",
  subDistrict: "",
  postCode: "",
}

export default {
  name: 'BuyCertification',
  components: {
    FooterWeb,
    Public,
    ThailandAutoComplete
  },
  data() {
    return {
      requestCertificate: false,
      requestDigitalSignature: false,
      service: true,
      requestERPConnect: false,
      price: 4900,
      useSameCompanyAddress: false,
      option: true,
      address: _.cloneDeep(addressObjectDetail),
      inputRule: [
        v => !!v || 'กรุณากรอกข้อมูล',
      ],
      alertProvince: false,
      alertAmphoe: false,
      alertDistrict: false,
      alertZipcode: false,
      alertTaxID: false,
    }
  },
  computed: mapState({
    companies: state => state.companies.list,
    companyAddress: state => state.companies.companyAddress,
    loading: state => state.companies.loading,
  }),
  created() {
    this.$store.dispatch('companies/getList')
  },
  mounted() {
    let elements = document.getElementsByClassName("vth-addr-input vth-addr-input-size-large")
    for (let i = 0; i < elements.length; i++) {
      elements[i].setAttribute("required", "required");
      if (i === 0) elements[i].setAttribute("id", "zipcode");
      if (i === 1) elements[i].setAttribute("id", "amphoe");
      if (i === 2) elements[i].setAttribute("id", "district");
      if (i === 3) elements[i].setAttribute("id", "province");

      elements[i].setAttribute("autocomplete", "off");

      elements[i].addEventListener('focusout', (event) => {
        if (event.target.value === '') {
          event.target.classList.add("input-error");
          event.target.parentNode.parentNode.nextElementSibling.classList.add("text-color-error")
          if (event.target.id === 'province') {
            this.alertProvince = true;
          }
          if (event.target.id === 'amphoe') {
            this.alertAmphoe = true;
          }
          if (event.target.id === 'district') {
            this.alertDistrict = true;
          }
          if (event.target.id === 'zipcode') {
            this.alertZipcode = true;
          }
        }
      });

      elements[i].addEventListener("keypress", () => {
        for (let i = 0; i < elements.length; i++) {
          elements[i].classList.remove("input-error");
          elements[i].parentNode.parentNode.nextElementSibling.classList.remove("text-color-error")
          this.alertProvince = false;
          this.alertAmphoe = false;
          this.alertDistrict = false;
          this.alertZipcode = false;
        }
      });
    }
  },
  methods: {
    checkEmptyCompany: function () {
      return !_.isEmpty(this.companies[0]['company'])
    },
    updatePricing: function () {
      this.price = 4900 + (this.requestCertificate ? 3000 : 0) + (this.requestDigitalSignature ? 2000 : 0) + (this.requestERPConnect ? 15000 : 0)
    },
    onChangeOption: function (option) {
      this.option = option
      if (!option) {
        this.requestCertificate = false;
        this.requestDigitalSignature = false;
        this.requestERPConnect = false;
        this.updatePricing()
      }
    },
    select(address) {
      this.address.subDistrict = address.district
      this.address.district = address.amphoe
      this.address.province = address.province
      this.address.postCode = address.zipcode
    },
    onsubmit: function (e) {
      e.preventDefault();
      let cerRequestObject = {
        address: this.address,
        price: this.price,
        requestCertificate: this.requestCertificate,
        requestDigitalSignature: this.requestDigitalSignature,
        requestERPConnect: this.requestERPConnect,
        service: this.service,
        created: new Date()
      }
       let companyID = this.$route.params.companyId
      if (companyID) {
        this.$store.dispatch('companies/createCerRequest', {companyID, cerRequestObject}).then(()=> {
          router.push('payment')
        })
      }
    },
    onChangeSelect: function (check) {
      this.useSameCompanyAddress = check
      if(check){
        this.onGetCompanyAddress();
      }else {
        this.address = _.cloneDeep(addressObjectDetail)
      }
      this.onChangeDisableAutocomplete(check)
    },
    onGetCompanyAddress: function () {
      let companyID = this.$route.params.companyId
      if (companyID) {
        this.$store.dispatch('companies/getCompanyAddress', {companyID})
      }
    },
    onChangeDisableAutocomplete: function (select) {
      let elements = document.getElementsByClassName("vth-addr-input vth-addr-input-size-large")
      for (let i = 0; i < elements.length; i++) {
        if (select) {
          elements[i].setAttribute("disabled", "disabled");
          elements[i].classList.add("disable");
        }
        else {
          elements[i].removeAttribute("disabled");
          elements[i].classList.remove("disable");
        }
      }
    },
  },
  watch: {
    companyAddress: {
      handler: function (companyAddress) {
        if(companyAddress){
          this.address = companyAddress
        }
      }
    }
  }
}
</script>

<style lang="scss">

#buy-certification {
  * {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif !important;
  }

  .v-input{
    border-radius: 10px;
  }
  .material-textfield {
    position: relative;

    label {
      position: absolute;
      font-size: 12px;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: white;
      color: rgba(0, 0, 0, 0.6);
      padding: 0 0.3rem;
      margin: 0 0.5rem;
      transition: .1s ease-out;
      transform-origin: left top;
      pointer-events: none;
      line-height: 10px;

      &.text-color-error {
        color: #b71c1c !important;
      }
    }

    input {
      font-size: 16px !important;
      border-radius: 10px !important;
      border: 1px solid rgba(0, 0, 0, 0.4) !important;
      //color: rgba(0, 0, 0, 0.6);
      transition: 0.5s ease-out;

      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.87) !important;
      }

      &:focus {
        border: 2px solid #6ec39b !important;
      }

      &.input-error {
        border: 2px solid #b71c1c !important;
      }

      &.disable {
        background-color: #f2f2f2;
        border: solid 1px #c4c4c4;
        color: rgba(0, 0, 0, 0.38);
      }
    }

    .vth-addr-container:focus-within + label {
      color: #6ec39b;
    }

    input[type="text"] {
      min-height: 56px;
      line-height: 28px;
    }
  }
  .input-address-error {
    font-size: 12px;
    color: #b71c1c;
    line-height: 2px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    margin-left: 13px;
  }

  .v-input--checkbox .v-input__slot {
    background-color: white !important;
  }

  .v-input--is-disabled .v-input__slot {
    background-color: #f2f2f2;
    color: rgba(0, 0, 0, 0.38);
  }

}

</style>
